"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unbookmarkProject = exports.bookmarkProject = exports.createProjectMetadata = exports.fetchProjects = void 0;
const t = require("io-ts");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const TypesLib = require("@caddigital/sok-types");
const types_1 = require("../types");
const ActionTypes = require("../actionTypes/projects");
const Actions = require("../actions/projects");
const errorHandling_1 = require("../utils/errorHandling");
function fetchProjects(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.FETCH_PROJECTS_REQUEST).pipe((0, operators_1.switchMap)((action) => {
        const params = Object.entries(action.payload)
            .map((x) => x.join('='))
            .join('&');
        return ajax({
            headers: {
                Authorization: getToken()
            },
            method: 'GET',
            url: `${baseUrl}api/project${params ? `?${params}` : ''}`
        }).pipe((0, operators_1.mergeMap)((res) => t
            .array(TypesLib.Project.iProject)
            .decode(res.response)
            .fold((error) => (0, rxjs_1.of)(Actions.fetchProjectsFailure((0, errorHandling_1.parseValidationError)(error))), (res) => (0, rxjs_1.of)(Actions.fetchProjectsSuccess(res)))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.fetchProjectsFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))));
    }));
}
exports.fetchProjects = fetchProjects;
function createProjectMetadata(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.CREATE_PROJECT_METADATA_REQUEST).pipe((0, operators_1.mergeMap)((action) => (0, rxjs_1.of)(action).pipe((0, operators_1.mergeMap)(({ payload }) => {
        return types_1.iCreateProjectMetadata
            .decode(payload.data)
            .fold(rxjs_1.throwError, () => (0, rxjs_1.of)(payload.data));
    }), (0, operators_1.mergeMap)((payload) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'POST',
        body: payload.metadata,
        url: `${baseUrl}api/projects/${payload.project_id}/metadata`
    })), (0, operators_1.mergeMap)(({ response }) => {
        return ActionTypes.iCreateProjectMetadataSuccessData
            .decode(response)
            .fold((e) => (0, rxjs_1.of)(Actions.createProjectMetadataFailure((0, errorHandling_1.parseValidationError)(e))), (res) => (0, rxjs_1.of)(Actions.createProjectMetadataSuccess(res)));
    }), (0, operators_1.catchError)((e) => (0, rxjs_1.of)(Actions.createProjectMetadataFailure((0, errorHandling_1.parseAjaxErrorResponse)(e)))))));
}
exports.createProjectMetadata = createProjectMetadata;
function bookmarkProject(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.BOOKMARK_PROJECT_REQUEST).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: payload,
        url: `${baseUrl}api/project/bookmark`
    }).pipe((0, operators_1.mergeMap)(({ response }) => ActionTypes.iBookmarkProjectSuccessData
        .decode(response)
        .fold((error) => (0, rxjs_1.of)(Actions.bookmarkProjectFailure((0, errorHandling_1.parseValidationError)(error))), (res) => (0, rxjs_1.of)(Actions.bookmarkProjectSuccess(res)))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.bookmarkProjectFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.bookmarkProject = bookmarkProject;
function unbookmarkProject(action$, store, { ajax, getToken, baseUrl }) {
    return action$.ofType(ActionTypes.UNBOOKMARK_PROJECT_REQUEST).pipe((0, operators_1.mergeMap)(({ payload }) => ajax({
        headers: {
            'Content-Type': 'application/json',
            Authorization: getToken()
        },
        method: 'PUT',
        body: payload,
        url: `${baseUrl}api/project/bookmark`
    }).pipe((0, operators_1.mergeMap)(({ response }) => t
        .array(t.number)
        .decode(response)
        .fold((e) => (0, rxjs_1.of)(Actions.unbookmarkProjectFailure((0, errorHandling_1.parseValidationError)(e))), (res) => (0, rxjs_1.of)(Actions.unbookmarkProjectSuccess(res)))), (0, operators_1.catchError)((error) => (0, rxjs_1.of)(Actions.unbookmarkProjectFailure((0, errorHandling_1.parseAjaxErrorResponse)(error)))))));
}
exports.unbookmarkProject = unbookmarkProject;
//# sourceMappingURL=projects.js.map